import { ZERO_HASH } from '../hash/hash';
export const circomSiblingsFromSiblings = (siblings, levels) => {
    for (let i = siblings.length; i < levels + 1; i += 1) {
        siblings.push(ZERO_HASH);
    }
    return siblings;
};
//# sourceMappingURL=circom.js.map